let text = {
  text: true,
  color: "v-sheet",
  textColor: "review",
  textType: "caption",
  minHeight: "44px",
  size: "default",
  iconSize: "default",
  fontWeight: "bold",
  textTransform: false,
  rounded: "lg",
};
let outlinedText = {
  outlined: true,
  text: true,
  color: "v-sheet",
  textColor: "review",
  textType: "caption",
  minHeight: "44px",
  size: "default",
  iconSize: "default",
  fontWeight: "bold",
  textTransform: false,
  rounded: "lg",
};

let outlinedTextStacked = {
  ...outlinedText,
  stacked: true,
};

let action = {
  depressed: true,
  block: false,
  iconSize: "20",
  color: "secondarySheet",
  textColor: "review",
  textType: "caption",
  fontWeight: "bold",
  textTransform: false,
  rounded: "lg",
};

let actionStacked = {
  ...action,
  stacked: true,
  textStyle: "font-size: x-small !important",
};

let stacked = {
  minHeight: "44px",
  iconSize: "20",
  textType: "caption",
  fontWeight: "bold",
  textTransform: false,
  stacked: true,
  textStyle: "font-size: x-small !important",
};

export const buttonPresets = {
  text,
  outlined: outlinedText,
  "outlined-stacked": outlinedTextStacked,
  action,
  "action-stacked": actionStacked,
  stacked,
};
